import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { PasswordInput } from "../components/ui/PasswordInput";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function PromoterLogin() {
  const { loginPromoter } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await loginPromoter(phone, password);
      toast.success("¡Bienvenido promotor!");
      navigate("/promotor");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-md mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="overline text-[hsl(var(--primary))]">Área de promotores</div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight mt-2">Inicia sesión</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          Accede a tu panel de promotor para ver tus comercios afiliados y comisiones del mes.
        </p>

        <form onSubmit={submit} className="mt-6 bg-white border border-border rounded-2xl p-4 sm:p-6 space-y-5" data-testid="promoter-login-form">
          <div>
            <Label className="text-sm">Teléfono (10 dígitos)</Label>
            <Input
              required
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
              placeholder="5512345678"
              inputMode="numeric"
              data-testid="promoter-login-phone"
            />
            {phone.length > 0 && phone.length < 10 && (
              <p className="text-[11px] text-amber-600 mt-1">{phone.length}/10 dígitos — faltan {10 - phone.length}</p>
            )}
            {phone.length === 10 && (
              <p className="text-[11px] text-green-600 mt-1">✓ Número completo</p>
            )}
          </div>
          <div>
            <Label className="text-sm">Contraseña</Label>
            <PasswordInput
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="promoter-login-password"
            />
          </div>
          <Button type="submit" disabled={busy} className="w-full btn-primary rounded-full py-6" data-testid="promoter-login-submit">
            <Sparkles className="w-4 h-4 mr-2" />
            {busy ? "Entrando…" : "Entrar a mi panel"}
          </Button>
          <div className="text-sm text-center">
            <Link to="/recuperar-contrasena?rol=promoter" className="text-muted-foreground hover:text-zinc-800 hover:underline" data-testid="promoter-forgot-password">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
          <div className="text-sm text-center text-muted-foreground">
            ¿Eres nuevo promotor? <Link to="/registro-promotor" className="text-[hsl(var(--primary))] font-medium">Regístrate aquí</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
